<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdmit_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.01 13c-.258 0-.516-.098-.712-.294L1.295 8.7a1.006 1.006 0 0 1 1.421-1.422l3.293 3.293 7.275-7.277a1.005 1.005 0 1 1 1.421 1.422L6.72 12.705a1 1 0 0 1-.71.295"
    />
</svg>
